var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"elevation":"0","disabled":!_vm.initialized},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("View Random Collection")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }